import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"
import _map from "lodash/map"
import OpenInvoicesSkeleton from "../OpenInvoicesSkeleton"

const InvoicesSkeleton = () => {
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const headerSectionClasses = classnames(
    styles.commons,
    styles.headerSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const moreOptionsClasses = classnames(
    styles.commons,
    styles.moreOptionsSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const invoicePaidClasses = classnames(
    styles.commons,
    styles.whiteBackgroundSkeleton,
    styles.invoicePaidSkeleton
  )

  const containerSelectClasses = classnames(
    styles.containerSelect,
    styles.skeleton
  )

  const moreOptionItemClasses = classnames(
    styles.moreOptionItem,
    styles.skeleton
  )

  const containerMoreItemClasses = classnames(
    styles.containerItem,
    "u-flex u-flexCol"
  )

  const itemInvoicePaidClasses = classnames(
    styles.itemInvoicePaid,
    styles.skeleton
  )

  return (
    <Fragment>
      <div className={titleClasses}></div>
      <div className={headerSectionClasses}>
        <div className={titleClasses}></div>
        <div className="u-flex u-flexJustifyBetween">
          <div className={containerSelectClasses}></div>
          <div className={containerSelectClasses}></div>
          <div className={containerSelectClasses}></div>
        </div>
      </div>
      <OpenInvoicesSkeleton />
      <div className={moreOptionsClasses}>
        <div className={titleClasses}></div>
        <div className="u-flex">
          <div className={containerMoreItemClasses}>
            <div className={moreOptionItemClasses}></div>
            <div className={moreOptionItemClasses}></div>
          </div>
          <div className={containerMoreItemClasses}>
            <div className={moreOptionItemClasses}></div>
            <div className={moreOptionItemClasses}></div>
          </div>
        </div>
      </div>
      <div className={invoicePaidClasses}>
        <div className={titleClasses}></div>
        {_map(Array(12), (_, index) => {
          return (
            <div className="u-flex u-flexJustifyBetween" key={index}>
              <div className={itemInvoicePaidClasses}></div>
              <div className={itemInvoicePaidClasses}></div>
            </div>
          )
        })}
      </div>
    </Fragment>
  )
}

export default InvoicesSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/InvoicesSkeleton/index.js